import { render, staticRenderFns } from "./sdGen.vue?vue&type=template&id=8609bb46&"
import script from "./sdGen.vue?vue&type=script&lang=js&"
export * from "./sdGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports